import React from 'react'
import './about.css'


import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Image from 'react-bootstrap/Image'
import picture from "../../assets/img/profile/picture.jpeg";



const  About = () => {
    return (
        <div id = 'about'>
            <div className="about">
                <h1 className="pt-3 text-center font-details pb-3">ABOUT ME</h1>
                <Container>
                    <Row className="pt-3 pb-5 align-items-center">
                        <Col xs={12} md = {6}>
                            <Row className="justify-content-center mb-2 mr-2 ">
                                <Image className="profile justify-content-end" alt="profile" src={picture} fluid roundedCircle />
                            </Row>
                        </Col>
                        <Col xs ={12} md= {6}>
                            <Row className=" align-items-start p-2 my-details rounded">
                                {/* Description */}
                                Greetings! I am <strong>&nbsp;Muhammad Ahmed</strong>
                                <br />I am web devloper from Pakistan. I am a Full Stack Web Developer with React.js, Redux, and python Django.
                                <br />
                                I am graduated from UET lahore pursuing my education in Computer Sciences.
                                <br />
                                In the past I have worked as a freelancer web developer on Fiver and made numerous Projects.
                                <br />
                                I have made numerous Applications in React like Portfolio design, Covid-19 Tracker, Netflix clone, AirBnB clone, weather application, Movies application.
                                <br/> I have also made numerous projects in Django like ecommerce store, Quiz applicationa and craiglist scrapping application.
                                <br />I love learning about new technologies, what problems are they solving and How can I use them to build better and scalable products.
                                <br /> <br />
                            </Row>

                            <Row>
                                {/* Buttons */}
                                <Col className="d-flex justify-content-center flex-wrap">
                                    <div>
                                        <a href="#contact">
                                            <Button className = "m-2" variant="info">Let's Connect</Button>
                                        </a>
                                    </div>
                                    <div>
                                        <a href="https://github.com/muhammadahmed004" target="_blank" rel="noopener noreferrer">
                                            <Button className="m-2" variant="info">
                                                GitHub
                                            </Button>
                                        </a>
                                    </div>
                                    <div>
                                        <a href="https://www.linkedin.com/in/muhammad-ahmed-450380176/" target="_blank" rel="noopener noreferrer">
                                            <Button className="m-2" variant="info">
                                                LinkedIn
                                            </Button>
                                        </a>
                                    </div>

                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
            
            
        </div>
    )
}

export default About;
